// export const Baseurl = 'http://localhost:3000'

export const Baseurl = 'https://api.medflixedu.com'

